import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../../Layout/Layout'
import { FetchBasePrice, FetchCustomerSpecificPrice, FetchDiscountDetails } from './productCatalogAPI';
import PriceUI from './ProductCommonUIs/PriceUI';

const PriceSection = ({ ProductID, ProductCardState: { PriceDetails }, setProductCardState, priceClass }) => {
    const { taxDetails: { AdditionalPricingOptions } } = useContext(AppContext);


    const FetchPriceData = async () => {

        if (AdditionalPricingOptions === "None") {
            const BasePriceDetails = await FetchBasePrice({ ProductID })
            setProductCardState({ type: "PriceDetails", payload: BasePriceDetails })
        }

        else if (AdditionalPricingOptions === "CSD") {
            const [BasePriceDetails, DiscountDetails] = await Promise.all([
                FetchBasePrice({ ProductID }),
                FetchDiscountDetails({ ProductID })
            ]);
            if (DiscountDetails.DiscountStatus === "Avl") {
                setProductCardState({ type: "PriceDetails", payload: { ...BasePriceDetails, ...DiscountDetails, Status: BasePriceDetails.Status === "BasePrice" ? "Discount" : BasePriceDetails.Status } })
            }
            else if (DiscountDetails.DiscountStatus === "NoDiscount") {
                setProductCardState({ type: "PriceDetails", payload: { ...BasePriceDetails, Status: BasePriceDetails.Status } })
            }
            else if (DiscountDetails.DiscountStatus === "ErrorDiscount") {
                setProductCardState({ type: "PriceDetails", payload: { Status: "ErrorPrice", ButtonStatus: "Unavailable" } })
            }
        }

        else if (AdditionalPricingOptions === "CSP") {
            const CSPDetails = await FetchCustomerSpecificPrice({ ProductID })
            if (CSPDetails.Status === "CSPPrice" || CSPDetails.Status === "NoPriceAvailable") {
                setProductCardState({ type: "PriceDetails", payload: CSPDetails })
            }
            else if (CSPDetails.Status === "NoCSPPrice") {
                const BasePriceDetails = await FetchBasePrice({ ProductID })
                setProductCardState({ type: "PriceDetails", payload: BasePriceDetails })
            }
        }
    }
    // console.log('PriceDetails', PriceDetails)
    useEffect(() => {
        FetchPriceData();
        //eslint-disable-next-line 
    }, [AdditionalPricingOptions, ProductID])


    return (
        <PriceUI PriceDetails={PriceDetails} priceClass={priceClass} />
    )
}

export default PriceSection